module.exports = __webpack_public_path__ + "static/img/jianli.97e8fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/jianli.png
// module id = ppog
// module chunks = 0